import React from "react";
import { useTranslation } from "react-i18next";
import DataCalculator from "../components/DataCalculator";
import Header from "../components/Header";
import Footer from "../components/Footer";

const FAQ = [
  ["calc.faq1q", "calc.faq1a"],
  ["calc.faq2q", "calc.faq2a"],
  ["calc.faq3q", "calc.faq3a"],
  ["calc.faq4q", "calc.faq4a"],
];

export default function CalculatorPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen" data-testid="calculator-page">
      <Header />
      <section className="relative overflow-hidden">
        <div className="absolute -top-10 -left-20 w-96 h-96 bg-cobalt-100 blob animate-blob pointer-events-none" />
        <div className="absolute -bottom-20 -right-20 w-96 h-96 bg-coral-soft/60 blob animate-blob pointer-events-none" style={{ animationDelay: "-4s" }} />
        <div className="max-w-5xl mx-auto px-5 lg:px-8 py-16 relative">
          <div className="overline mb-3">{t("calc.eyebrow")}</div>
          <h1 className="font-display font-bold text-5xl md:text-6xl tracking-tight">{t("calc.pageTitle")}</h1>
          <p className="mt-4 text-ink-700 max-w-2xl text-lg">{t("calc.pageSub")}</p>
          <div className="mt-10">
            <DataCalculator />
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <div className="overline mb-3">{t("home.faqEyebrow")}</div>
          <h2 className="font-display font-bold text-4xl tracking-tight mb-8">{t("calc.faqTitle")}</h2>
          <div className="space-y-3">
            {FAQ.map(([q, a], i) => (
              <details key={i} className="card-soft !rounded-2xl px-6 py-5 group" data-testid={`calc-faq-${i}`}>
                <summary className="font-display font-semibold text-lg cursor-pointer list-none flex items-center justify-between">
                  {t(q)}
                  <span className="text-cobalt-500 group-open:rotate-45 transition">+</span>
                </summary>
                <div className="mt-3 text-ink-700 leading-relaxed">{t(a)}</div>
              </details>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
